import React from 'react';
import { ModeProps } from '../../types';
import { Button } from '../ui/Button';
export function FinalCTA({
  mode
}: ModeProps) {
  const isBusiness = mode === 'business';
  return <section className="py-32 bg-slate-900" data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-245">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight" data-id="element-246">
          {isBusiness ? 'Build the future of finance on Obseq.' : 'Get started with Obseq'}
        </h2>
        {isBusiness && <p className="text-base sm:text-lg text-slate-400 mb-8 sm:mb-10 max-w-2xl mx-auto" data-id="element-247">
            Join hundreds of fintechs and platforms moving billions globally
            with our regulated infrastructure.
          </p>}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-248">
          {isBusiness ? <a href="mailto:sales@obseq.xyz" data-id="element-249">
              <Button size="lg" className="min-w-[160px] bg-white text-slate-900 hover:bg-slate-100" data-id="element-250">
                Talk to Sales
              </Button>
            </a> : <Button size="lg" className="min-w-[160px] bg-white text-slate-900 hover:bg-slate-100" data-id="element-251">
              Join the Waitlist
            </Button>}
          {isBusiness && <a href="#/docs" data-id="element-252">
              <Button variant="outline" size="lg" className="min-w-[160px] border-slate-700 text-white hover:bg-slate-800" data-id="element-253">
                View API Docs
              </Button>
            </a>}
        </div>
      </div>
    </section>;
}